import { lazy } from 'react';

// project import
import MainLayout from 'layout/MainLayout';
import Loadable from 'components/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import { Navigate } from 'react-router';

// pages
const BrandsTable = Loadable(lazy(() => import('pages/config/brandsTable')));
const UserRolesTable = Loadable(lazy(() => import('pages/config/userRolesTable')));
const BrandCompaniesTable = Loadable(lazy(() => import('pages/config/brandCompaniesTable')));

// ==============================|| APPS ROUTING ||============================== //

const ConfigRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: 'config',
          children: [
            {
              path: '',
              element: <Navigate to="brand-companies" />
            },
            {
              path: 'brand-companies',
              element: <BrandCompaniesTable />
            },
            {
              path: 'brands',
              element: <BrandsTable />
            },
            {
              path: 'users',
              element: <UserRolesTable />
            }
          ]
        }
      ]
    }
  ]
};

export default ConfigRoutes;
